import about from 'data/about.json';
import projects from 'data/projects.json';

export const en = {
  about,
  projects,
  languageSelect: 'Language',
  themeToggle: 'Toggle theme',
  nav: {
    home: 'Home',
    about: 'About',
    experience: 'Experience',
    projects: 'Projects',
    articles: 'Articles',
    contact: 'Contact',
    getInTouch: 'Get in Touch',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
  },
  hero: {
    badge: 'Full Stack Engineer',
    greeting: "Hi, I'm",
    subtitle: 'Building High-Performance Applications',
    intro: 'Passionate Full Stack Developer with expertise in building modern web applications from concept to deployment. I create',
    secure: 'secure',
    scalable: 'scalable',
    and: 'and',
    userFriendly: 'user-friendly',
    outro: 'solutions following industry best practices and Agile methodologies.',
    getInTouch: 'Get in Touch',
    viewProjects: 'View Projects',
  },
  aboutSection: {
    badge: 'About Me',
    title: 'Full Stack Engineer',
    description:
      'Passionate about building high-performance, secure applications with clean architecture. I combine technical expertise with strong problem-solving skills to deliver user-centered solutions.',
    technicalSkills: 'Technical Skills',
    backend: 'Backend Development',
    frontend: 'Frontend Development',
    database: 'Database & Storage',
    devops: 'DevOps & Cloud',
    practices: 'Practices & Methodologies',
  },
  experienceSection: {
    badge: 'Career',
    title: 'Professional Experience',
    description: 'Building impactful solutions across fintech, e-payment, and enterprise platforms.',
    internship: 'Internship',
    fullTime: 'Full-time',
  },
  projectsSection: {
    badge: 'Portfolio',
    title: 'Professional Projects',
    description:
      'Enterprise-level solutions featuring microservices architecture, secure authentication, and modern full-stack technologies across various domains.',
    internshipProjects: 'Internship Projects',
  },
  articlesSection: {
    badge: 'Blog & Insights',
    title: 'Technical Articles',
    description:
      'I write about full-stack development, clean code practices, and modern software engineering. All of it now lives on my blog.',
    cta: 'Read my blog',
  },
  contactSection: {
    badge: 'Get in Touch',
    title: "Let's Work Together",
    description:
      "I'm currently available for freelance projects or full-time opportunities. Let's discuss how I can help bring your ideas to life.",
    infoTitle: 'Contact Information',
    infoDescription: 'Feel free to reach out through any of these channels',
    email: 'Email',
    location: 'Location',
    linkedinValue: 'Connect with me',
    remote: 'Available for remote work',
    messageTitle: 'Quick Message',
    messageDescription: 'Send me a direct message or schedule a call',
    helpTitle: 'What I can help with:',
    helpItems: [
      'Full-stack web application development',
      'Microservices architecture and design',
      'Code review and optimization',
      'Technical consultation and mentoring',
    ],
    responseTitle: 'Response Time:',
    responseText: 'I typically respond within 24 hours during weekdays. Looking forward to hearing from you!',
    sendEmail: 'Send Email',
    connectLinkedin: 'Connect on LinkedIn',
    ctaTitle: 'Open to Opportunities',
    ctaText: 'Currently exploring new challenges in full-stack development and microservices architecture.',
    downloadResume: 'Download Resume',
    viewGithub: 'View GitHub Profile',
  },
  footer: {
    tagline: 'Full Stack Engineer passionate about building high-performance, secure applications with clean architecture.',
    quickLinks: 'Quick Links',
    getInTouch: 'Get in Touch',
    openToOpportunities: 'Open to new opportunities',
    remote: 'Available for remote work',
    rights: 'All rights reserved.',
  },
  scrollToTop: 'Scroll to top',
};
